import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import EADatePicker from "components/common/EADatePicker";

const AttributeDateInput = ({onError = () => {}, setSelectedAttribute = () => {}, save = () => {} }) => {
  const formMethods = useFormContext();
  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    if (!isFocused) {
      setSelectedAttribute(null);
    }
  // eslint-disable-next-line
  }, [isFocused]);

  return (
    <Controller
      control={formMethods.control}
      name="value"
      render={({ field }) => (
        <EADatePicker
          {...field}
          formMethods={formMethods}
          onlyDate
          autoFocus
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          save={save}
          sxClass={{
            width: "200px",
            height: "100%",
            "& .MuiOutlinedInput-root": {
              border: "none",
              borderRadius: "0 12px 12px 0",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root": {
              left: "31px",
              top: "-9px"
            },
            "& .MuiInputLabel-shrink": {
              left: "0px",
              top: "0px"
            },
          }}
          onError={onError}
          ref={null}
        />
      )}
    />
  );
};
export default AttributeDateInput;
